import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subpage-asesoramiento-psico-pedagogico-permanente-al-educador',
  templateUrl: './subpage-asesoramiento-psico-pedagogico-permanente-al-educador.component.html',
  styleUrls: ['./subpage-asesoramiento-psico-pedagogico-permanente-al-educador.component.scss']
})
export class SubpageAsesoramientoPsicoPedagogicoPermanenteAlEducadorComponent implements OnInit {

  constructor() { 
    window.scroll(0,0);
  }

  ngOnInit() {
  }

}
